<template>
    <span class="tw-flex">
        <TRadioButton
            activeClass="tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500"
            value="true"  :modelValue="'' + value" @input.stop @update:modelValue="update">True</TRadioButton>
        <TRadioButton
            activeClass="tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500"
            value="false" :modelValue="'' + value" @input.stop @update:modelValue="update">False</TRadioButton>
    </span>
</template>
<script>
import { 
    TRadioButton
} from '@roonlabs/vue-tailwind'
export default {
    name: 'BooleanInput',
    components: { TRadioButton },
    props: {
        value: Boolean
    },
    methods: {
        update(e) {
            this.$emit('input', e == 'true' ? true : false);
        }
    }
}
</script>
